module.exports = __webpack_public_path__ + "static/media/jeffWiener.71ade2b1.png";